import { store } from '../../../../../../../../store';

export const getNextRefillCheck = (refill_type) => {
  const services = store.getState().services;
  const { config } = services;
  /**
   * При refill_paid_options === false
   * refill_check всегда выключаем
   */
  if (!config.refill_paid_options) {
    return false;
  }
  if (refill_type) {
    switch (refill_type) {
    case 1:
      return false;
    case 2:
    case 3:
      return true;
    default:
      return false;
    }
  }
  return new Error(`not found form - ${typeof refill_type}`);
};

export const getAccessMinimalQuantity = (refill, config) => {
  if (refill && config) {
    const { refill_type, refill_check } = refill;
    const { refill_paid_options } = config;
    switch (refill_type) {
    case 2:
      return true;
    case 3:
      return !!(refill_paid_options && refill_check);
    default:
      return false;
    }
  }
  return false;
};

export const getAccessCount = (refill, config) => {
  if (refill && config) {
    const { refill_type, refill_check } = refill;
    const { refill_paid_options } = config;
    if (refill_paid_options) {
      switch (refill_type) {
      case 2:
        return true;
      case 3:
        return !!refill_check;
      default:
        return false;
      }
    }
  }
  return false;
};

export const getAccessProvider = (refill, config) => {
  if (refill && config) {
    const { refill_type } = refill;
    const { refill_paid_options } = config;
    return refill_paid_options && refill_type === 2;
  }
  return false;
};

export const getAccessRefillCheck = (config) => {
  if (config) {
    const { refill_paid_options } = config;
    return refill_paid_options;
  }
  return false;
};
